// extracted by mini-css-extract-plugin
export default {"container":"PharmacyOrdersTab_container__5kfVn"};